"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How quickly can Atlas Surgical Partners provide coverage for our facility?",
  answer: "We specialize in rapid-response staffing solutions. Depending on your facility's specific requirements and location, we can often present qualified surgical candidates within 24 to 48 hours to ensure your operating rooms stay on schedule and fully functional."
}, {
  question: "What credentialing standards do you maintain for your clinicians?",
  answer: "Every clinician in our network undergoes a rigorous vetting process, including primary source verification of licenses, comprehensive background checks, and clinical competency assessments tailored specifically to surgical specialties and enterprise healthcare standards."
}, {
  question: "Do you support both short-term and long-term staffing needs?",
  answer: "Yes. Whether you require coverage for a single shift, a maternity leave, or a long-term contractual arrangement, our platform is designed to scale effortlessly with your facility's specific volume and specialty requirements."
}, {
  question: "How does the 'Request Coverage' process work for new facilities?",
  answer: "Simply click 'Request Coverage' to provide your facility details and staffing needs. Our team will immediately begin matching you with top-tier surgical professionals from our curated network, ensuring a seamless integration into your clinical workflow."
}];
export default function Faq() {
  return <section data-section-id="180680" id="frequentlyaskedquestions" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="bg-card rounded-[2rem] p-8 md:p-12 lg:p-16 shadow-sm border border-border/50">
          <div className="text-center mb-12">
            <h2 className="font-default text-3xl md:text-4xl font-bold text-primary mb-4 tracking-tight before:content-[''] before:block before:w-12 before:h-1 before:bg-accent-foreground before:mx-auto before:mb-6 before:rounded-full">
              Frequently Asked Questions
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed font-sans">
              Everything you need to know about partnering with Atlas Surgical Partners for premium, reliable surgical staffing solutions.
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="w-full space-y-4">
              {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-white border border-border rounded-xl overflow-hidden shadow-sm data-[state=open]:shadow-md transition-all duration-200 last:border-b">
                  <AccordionTrigger className="px-6 py-5 hover:no-underline text-base md:text-lg font-default font-semibold text-primary hover:text-secondary transition-colors duration-200 [&>svg]:text-secondary [&>svg]:size-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-6 pt-0 text-muted-foreground text-base leading-relaxed font-sans">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}